import React, { ReactElement, useEffect, useState } from 'react';
import { Button, Card, Image, Modal } from 'react-bootstrap';
import { ImageCustom } from '../../../../common/components/ImageCustom';
import {
  useGetGiftTopAudienceMutation,
  useGetLiveAudiencesMutation,
  useGetPersonalDataMutation,
} from '../../../../services/api/apiProvider';
import { ResponseAudience } from '../../../../services/api/models/response/responseAudience';
import { LiveProps } from '../../LiveContainer';
import './LiveAudiences.scss';
import giftTopIcon from '../../../../assets/svg/gift_top.svg';
import { getLevelColor } from '../../../../common/utils/utils';

import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import LiveProfileModal from '../LiveProfileModal/LiveProfileModal';
import { actions } from '../../liveSlice';
import { updateUserData } from '../../../profile/slices/profilePageSlice';

export const LiveAudiences = (props: LiveProps): ReactElement => {
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const [audiences, setAudiences] = useState<ResponseAudience[]>([]);

  const [getAudiences] = useGetLiveAudiencesMutation();
  const [getTopAudience] = useGetGiftTopAudienceMutation();
  const [getPersonalData] = useGetPersonalDataMutation();

  const UPDATE_CYCLE = 15000;

  /**
   * Fetch audiences data from API.
   */
  const fetchAudiencesData = () => {
    if (props.liveState.liveData) {
      getAudiences(props.liveState.liveData.id)
        .unwrap()
        .then((data) => {
          setAudiences(data);
        });
    }
  };

  /**
   * Get GiftTop user
   * @param audience
   */
  const fetchGiftTopAudience = () => {
    if (
      props.liveState.giftTopAudience === undefined &&
      props.liveState.liveData
    ) {
      // update gift top
      getTopAudience(props.liveState.liveData?.id)
        .unwrap()
        .then((listAudience) => {
          if (listAudience.length > 0) {
            props.setGiftTopAudience(listAudience[0]);
          } else {
            props.setGiftTopAudience(undefined);
          }
        });
    }
  };

  useEffect(() => {
    const timer = setInterval(() => {
      if (props.liveState.isInLive && props.liveState.liveData) {
        fetchAudiencesData();
        fetchGiftTopAudience();
      }
    }, UPDATE_CYCLE);
    return () => {
      clearInterval(timer);
    };
  }, [props.liveState.isInLive]);

  const handleShowModalProfile = async (id: string) => {
    const data = await getPersonalData(id).unwrap();
    if (data) {
      dispatch(updateUserData(data));
    }
    dispatch(actions.toggleProfileModal(true));
  };

  const handleCloseModalConfirm = () => {
    dispatch(actions.toggleConfirmBlockedModal(false));
  };

  const renderAudiences = () => {
    return (
      <ul className="list-audi">
        {/* Gift Top audience */}
        {props.liveState.giftTopAudience !== undefined ? (
          <li
            onClick={() => {
              if (props.liveState.giftTopAudience) {
                handleShowModalProfile(props.liveState.giftTopAudience?.id);
              }
            }}
            className="d-flex list-audi__item"
          >
            <div className="d-flex flex-column gift-top">
              <div className="audi-item__avatar_top">
                <Image
                  src={props.liveState.giftTopAudience?.picture.uri}
                  style={{ width: '48px', height: '48px' }}
                />
                <Image
                  src={giftTopIcon}
                  className="audi-item__avatar_top"
                ></Image>
              </div>
            </div>
            <div className="d-flex flex-column audi-item__info">
              <div className="d-flex align-items-center">
                <div className="d-flex flex-column">
                  <div className="audi-item__info__name">
                    {props.liveState.giftTopAudience.loginId}
                  </div>
                </div>
                <div className="d-flex flex-column">
                  <span
                    className="audi-item__info__level"
                    style={{
                      backgroundColor: getLevelColor(
                        props.liveState.giftTopAudience.level,
                      ),
                    }}
                  >{`Lv.${props.liveState.giftTopAudience.level}`}</span>
                </div>
                <div className="d-flex flex-column">
                  <span className="audi-item__info__top_badge">{`ギフトトップ`}</span>
                </div>
              </div>
            </div>
          </li>
        ) : (
          <></>
        )}

        {/* List audience */}
        {audiences.map((au) => (
          <li
            onClick={() => handleShowModalProfile(au.id)}
            key={au.id}
            className="d-flex list-audi__item"
          >
            <div className="d-flex flex-column">
              <div className="audi-item__avatar">
                <ImageCustom src={au.picture.uri} />
              </div>
            </div>
            <div className="d-flex flex-column audi-item__info">
              <div className="d-flex align-items-center">
                <div className="d-flex flex-column">
                  <div className="audi-item__info__name">{au.loginId}</div>
                </div>
                <div className="d-flex flex-column">
                  <span
                    className="audi-item__info__level"
                    style={{ backgroundColor: getLevelColor(au.level) }}
                  >{`Lv.${au.level}`}</span>
                </div>
              </div>
            </div>
          </li>
        ))}
      </ul>
    );
  };

  return (
    <div className="live-audiences">
      <Card className="live-audiences__content box-shadow-2">
        <Card.Header className="live-audiences__count">
          {t('Audiences')} {audiences.length > 0 ? `(${audiences.length})` : ''}
        </Card.Header>
        <Card.Body className="live-audiences__body">
          {renderAudiences()}
        </Card.Body>
      </Card>

      {/* Modal profile user */}
      <LiveProfileModal {...props} />

      {/* Modal confirm blocked */}
      <Modal
        backdrop="static"
        keyboard={false}
        centered
        scrollable={true}
        show={props.liveState.isShowConfirmBlockedModal}
      >
        <Modal.Body>
          <div className="dialog-confirm-block-content">
            ユーザーをブロックしました
          </div>
        </Modal.Body>

        <Modal.Footer style={{ justifyContent: 'center' }}>
          <Button variant="primary" onClick={handleCloseModalConfirm}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
